var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{attrs:{"size":"sm","color":"primary","round":"","flat":"","dense":"","icon":_vm.expand ? _vm.$icons.imRemove : _vm.$icons.imAdd},on:{"click":function($event){_vm.expand = !_vm.expand}}})}
var staticRenderFns = []

export { render, staticRenderFns }